/**
 * Top padding for imagery routes under the fixed app header (inset chrome +
 * rounded panel). Tuned to enrichment-style `enrichmentChromeViewportInset` +
 * `enrichmentDarkSlimPadding` row height.
 */
export const IMAGERY_HEADER_INSET = "6rem";
